import { DemoIndicatorColoredIcon } from '@carboncopyco/icons';
import type { IDemo } from '@carboncopyco/types';
import { RecordingTypes } from '@carboncopyco/types';
import { TooltipBubble } from '@carboncopyco/ui';
import { useCallback } from 'react';
import { SearchResultTile } from '../../../GridTiles';
import { useWorkspacePageProps } from '../WorkspacePageContext';
import { DemoActionsDropdown } from './EntitiesActionsDropdown/DemoActionsDropdown';

interface DemoSearchResultTileProps {
  demo: IDemo;
  archived?: boolean;
  inFolder?: boolean;
}

export const DemoSearchResultTile = ({
  demo,
  archived,
  inFolder,
}: DemoSearchResultTileProps) => {
  const { goToDemo } = useWorkspacePageProps();

  const DropdownAction = useCallback(
    ({ toggleMenu }: { toggleMenu: () => void }) => {
      return (
        <DemoActionsDropdown
          demo={demo}
          handleMenuOpen={toggleMenu}
          archived={archived}
          inFolder={inFolder}
        />
      );
    },
    [demo, archived, inFolder]
  );

  return (
    <SearchResultTile
      lastUpdated={demo.updateTime}
      title={demo.demoName}
      image={demo.image}
      totalPresentations={demo.totalPresentations}
      totalShares={demo.totalShares}
      isDesktop={demo.recordingType === RecordingTypes.native}
      onTileClick={
        archived ? undefined : () => goToDemo(String(demo.id), demo.workspaceId)
      }
      ActionDropdown={DropdownAction}
      icon={
        <TooltipBubble
          placement="top"
          title="Demo (cloned app)"
        >
          <DemoIndicatorColoredIcon size={18} />
        </TooltipBubble>
      }
    />
  );
};
